import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  decimalValue,
  getMerchantCurrencySymbol,
  searchTableHandler,
  searchTextVal,
} from "../../../helpers";
import { changeMenuValue, getMenuRecipes } from "../../../Redux/actions";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Recipes = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { recipe_details } = useSelector((state) => state.menuReducer);
  const { user_details } = useSelector((state) => state.authReducer);
  const [listStatus, setListStatus] = useState(3);
  const pagesize = 10;

  const getRecipesHandler = (page = 1, status = 3) => {
    dispatch(getMenuRecipes({ page, status, pagesize }));
  };

  useEffect(() => {
    getRecipesHandler();

    return () => {
      dispatch(changeMenuValue("recipe_details", null));
    };
  }, []);

  useEffect(() => {
    getRecipesHandler(1, listStatus);
  }, [listStatus]);

  const getTotalRecipeCostDiv = (recipe) => {
    return `${decimalValue(
      recipe?.total_recipe_cost,
      2,
      getMerchantCurrencySymbol(user_details)
    )}`;
  };

  const getPaginationContainer = () => {
    let res = null;
    if (
      checkNull(recipe_details?.last_page, false) &&
      recipe_details?.last_page > 1
    ) {
      const pagesArr = Array.from(
        { length: recipe_details?.last_page },
        (_, i) => i + 1
      );
      res = (
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            {pagesArr.map((pageNo) => {
              return (
                <li
                  class={`page-item${
                    pageNo == recipe_details?.current_page ? " active" : ""
                  }`}
                  onClick={() => {
                    if (!(pageNo == recipe_details?.current_page)) {
                      getRecipesHandler(pageNo, listStatus);
                    }
                  }}
                >
                  <a class="page-link">{pageNo}</a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    }
    return res;
  };

  const getRecipeActionBtn = (recipe) => {
    let res = null;
    if (
      (recipe?.parent_id > 0 &&
        recipe?.merchant_id == user_details?.user?.merchant_id) ||
      (checkNull(recipe?.parent_id, false) && recipe?.is_editable == 2)
    ) {
    } else {
      res = (
        <a
          class="circle_icon"
          onClick={() => history.push(`/menu/recipes/edit/${recipe?.id}`)}
        >
          <i class="iconSprites edit-icon">
            <div class="tooltip-sm"> Edit </div>
          </i>
        </a>
      );
    }
    return res;
  };

  // search
  const [recipeSearch, setRecipeSearch] = useState("");
  const recipeSearchHandler = (recipe) => {
    let resp = true;
    if (checkNull(recipeSearch, false)) {
      let searchText = recipeSearch.toLowerCase();
      resp = false;
      if (
        searchTableHandler(
          [
            recipe?.id,
            recipe?.recipe_name,
            recipe?.menu_class?.name,
            recipe?.number_of_servings,
            getTotalRecipeCostDiv(recipe),
          ],
          searchText
        )
      ) {
        resp = true;
      }
    }
    return resp;
  };

  const getRecipeTableCon = () => {
    return (
      <div className="table-responsive">
        <table
          width="100%"
          cellspacing="0"
          cellpadding="0"
          class="checklist-table table850 remove-space inventory_table"
        >
          <thead>
            <tr>
              <th> ID </th>
              {user_details?.user?.merchant?.parent_merchant_id > 0 && (
                <th> Parent ID </th>
              )}
              <th>
                <span>Recipe Name</span>
              </th>
              <th>Category</th>
              <th>Number Of Servings</th>
              <th>Total Recipe Cost</th>
              <th className="action-td"> Action </th>
            </tr>
          </thead>
          <tbody>
            {checkArray(recipe_details?.recipes?.data) &&
              recipe_details?.recipes?.data
                .filter((item) => recipeSearchHandler(item))
                .map((recipe) => {
                  return (
                    <tr>
                      <td>{recipe?.id}</td>
                      {user_details?.user?.merchant?.parent_merchant_id > 0 && (
                        <td>{recipe?.parent_id ?? "NA"}</td>
                      )}
                      <td>
                        <span>{checkNull(recipe?.recipe_name)}</span>
                      </td>
                      <td>{checkNull(recipe?.menu_class?.name)}</td>
                      <td>{checkNull(recipe?.number_of_servings)}</td>
                      <td>{getTotalRecipeCostDiv(recipe)}</td>
                      <td className="action-td">
                        {getRecipeActionBtn(recipe)}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
        {getPaginationContainer()}
      </div>
    );
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="shadowclass">
                  <div className="top-header-sec d-flex justify-content-between mb-0">
                    <h4 className="event-alert mb-3 col-md-4">
                      Recipes List
                      <div className="clear"></div>
                    </h4>
                    <ul
                      class="nav summary_filter col-md-4"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <a
                          class={`nav-link${listStatus == 3 ? " active" : ""}`}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected={`${
                            listStatus == 3 ? "true" : "false"
                          }`}
                          onClick={() => setListStatus(3)}
                        >
                          Active
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          class={`nav-link${listStatus == 3 ? "" : " active"}`}
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected={`${
                            listStatus == 3 ? "false" : "true"
                          }`}
                          onClick={() => setListStatus(4)}
                        >
                          Inactive
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="row justify-content-between align-items-center w-100 mx-0">
                    <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                      <div className="search-box mt-0">
                        <form type="GET">
                          <input
                            type="text"
                            placeholder="Search"
                            name="keyword1"
                            value={recipeSearch}
                            autocomplete="off"
                            onChange={(e) =>
                              setRecipeSearch(e?.target?.value ?? "")
                            }
                          />
                          <input type="button" />
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-7 col-12 align-right px-0">
                      <div class="field text-right">
                        <button
                          class="btn green-btn-revert add-plus addSp mx-0"
                          id="addCount"
                          type="button"
                          onClick={() =>
                            history.push("/menu/recipes/new-recipe")
                          }
                        >
                          <i class="i-icon"> </i> Add Recipe
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row mx-0 my-4">
                    <div class="tab-content px-0" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {getRecipeTableCon()}
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-profile"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                      >
                        {getRecipeTableCon()}
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-contact"
                        role="tabpanel"
                        aria-labelledby="pills-contact-tab"
                      >
                        ...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Recipes;
